import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    async function checkToken() {
      if (!token) { setChecking(false); return; }
      try {
        const r = await fetch(`/api/auth/reset-password/check?token=${token}`);
        const d = await r.json();
        setTokenValid(d.valid);
      } catch { setTokenValid(false); }
      finally { setChecking(false); }
    }
    checkToken();
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (newPassword !== confirm) { setError('Passwörter stimmen nicht überein'); return; }
    if (newPassword.length < 8) { setError('Mindestens 8 Zeichen'); return; }
    setLoading(true);
    try {
      const r = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });
      const d = await r.json();
      if (d.success) setDone(true);
      else setError(d.error || 'Fehler beim Zurücksetzen');
    } catch { setError('Verbindungsfehler'); }
    finally { setLoading(false); }
  }

  const base = {
    minHeight: '100vh',
    background: 'radial-gradient(ellipse at top, #1a1a1a 0%, #0a0a0a 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif',
    color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem'
  };
  const inp = { width: '100%', boxSizing: 'border-box', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12, padding: '0.75rem 1rem', color: '#fff', fontSize: '0.95rem', outline: 'none', fontFamily: 'inherit' };
  const lbl = { display: 'block', fontSize: '0.72rem', fontWeight: 600, color: 'rgba(255,255,255,0.5)', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.5px' };

  if (checking) return <div style={{ ...base, color: 'rgba(255,255,255,0.4)' }}>Prüfe Link…</div>;

  return (
    <div style={base}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: 24, padding: '2.25rem', boxShadow: '0 24px 60px rgba(0,0,0,0.4)', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: 'linear-gradient(90deg, #f7d98f, #d9aa43)', borderRadius: '24px 24px 0 0' }} />

          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <img src="/logo.webp" alt="TDA" style={{ width: 64, height: 64, borderRadius: 16, marginBottom: '1rem', boxShadow: '0 8px 24px rgba(0,0,0,0.3)' }} />
            <h2 style={{ margin: '0 0 0.25rem', fontSize: '1.4rem', fontWeight: 700 }}>Neues Passwort</h2>
          </div>

          {!token || !tokenValid ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️</div>
              <p style={{ color: '#fca5a5', fontWeight: 600, marginBottom: '0.5rem' }}>Link ungültig oder abgelaufen</p>
              <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>Bitte fordern Sie einen neuen Reset-Link an.</p>
              <button onClick={() => navigate('/forgot-password')} style={{ width: '100%', padding: '0.875rem', background: 'linear-gradient(135deg, #f7d98f, #8b5a12)', border: 'none', borderRadius: 12, color: '#0b0c10', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                Neuen Link anfordern
              </button>
            </div>
          ) : done ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✅</div>
              <p style={{ color: '#34d399', fontWeight: 600, marginBottom: '0.5rem' }}>Passwort geändert!</p>
              <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>Sie können sich jetzt mit Ihrem neuen Passwort einloggen.</p>
              <button onClick={() => navigate('/login')} style={{ width: '100%', padding: '0.875rem', background: 'linear-gradient(135deg, #f7d98f, #8b5a12)', border: 'none', borderRadius: 12, color: '#0b0c10', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                Zum Login
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <label style={lbl}>Neues Passwort</label>
                <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Min. 8 Zeichen" required disabled={loading} style={inp} autoComplete="new-password" />
              </div>
              <div>
                <label style={lbl}>Passwort bestätigen</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Passwort wiederholen" required disabled={loading} style={inp} autoComplete="new-password" />
              </div>

              {error && (
                <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '0.7rem 1rem', color: '#fca5a5', fontSize: '0.85rem' }}>{error}</div>
              )}

              <button type="submit" disabled={loading} style={{ padding: '0.875rem', background: loading ? 'rgba(139,90,18,0.5)' : 'linear-gradient(135deg, #f7d98f, #8b5a12)', border: 'none', borderRadius: 12, color: '#0b0c10', fontWeight: 700, fontSize: '0.9rem', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
                {loading ? 'Speichern…' : 'Passwort speichern'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
